export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70 py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
              Superbuy Spreadsheet
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your ultimate curated shopping companion. Find verified products,
              QC references, and expert guides all in one place.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <a href="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Home
              </a>
              <a href="/what-is-superbuy-spreadsheet/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Beginner Guide
              </a>
              <a href="/how-to-use-superbuy-spreadsheet/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                How to Use
              </a>
              <a href="/superbuy-spreadsheet-beginner-guide/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                New User Guide
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">Guides &amp; Resources</h4>
            <nav className="flex flex-col gap-2">
              <a href="/is-superbuy-spreadsheet-safe/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Safety Guide
              </a>
              <a href="/superbuy-spreadsheet-qc/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                QC Guide
              </a>
              <a href="/superbuy-spreadsheet-shipping-guide/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Shipping Guide
              </a>
              <a href="/superbuy-spreadsheet-review/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Honest Review
              </a>
              <a href="/superbuy-spreadsheet-alternative/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Alternatives
              </a>
              <a href="/superbuy-spreadsheet-links/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Resource Links
              </a>
              <a href="/superbuy-spreadsheet-shoes/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                Shoes Guide
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">Visit Our Store</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-6 py-2.5 rounded-full transition-all duration-300 text-sm cursor-pointer"
            >
              <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
              Visit kaspreadsheet.com
            </a>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 superbuyspread.baby — All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This site provides informational content and curated links. We are not affiliated with Superbuy or any shopping agent.
          </p>
        </div>
      </div>
    </footer>
  );
}